import { Targeting } from './targeting';
var createInstance = function () {
    var targeting = new Targeting();
    return {
        evaluateTargeting: targeting.evaluateTargeting.bind(targeting),
    };
};
export default createInstance();
//# sourceMappingURL=targeting-factory.js.map